export class VendorContact {
  firstName: string = null;
  lastName: string = null;
  title: string = null;
  phoneNumber: string = null;
  email: string = null;
  instantBookingEmail: string = null;
  quoteRequestEmail: string = null;
  salesAgentName: string = null;
}
